import ACTIONS from '@/store/storeActions';
import LoadingState from '@/api/LoadingState';
import ScheduleEntryTypes from '@/libs/constants';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isEqual from 'lodash.isequal';
import mergeArray from '@/store/storeHelper';

dayjs.extend(isSameOrBefore);

const mutations = {
  [ACTIONS.SET_RUN_INFO]: (state, payload) => {
    // initial setup on personalization
    const {
      status,
      appointments,
      exercises,
      participant
    } = payload;
    state.runInformation = payload
    if (exercises && Array.isArray(exercises)) state.exercises = mergeArray(state.exercises, exercises)
    if (participant) state.participant = { ...state.participant, ...participant }
    if (appointments && Array.isArray(appointments)) {
      state.loadingState = { ...state.loadingState, timetable: LoadingState.LOADING }
      // add to existing timetable if new objects appear
      let timetableEarliestStart = 7;
      const tmp = appointments.map((entry) => {
        /* eslint-disable no-param-reassign */
        entry.startTime = dayjs(entry.startTime).format('YYYY-MM-DD HH:mm:ss')
        entry.endTime = dayjs(entry.endTime).format('YYYY-MM-DD HH:mm:ss')
        const startingHour = dayjs(entry.startTime).hour();
        if (startingHour < timetableEarliestStart) timetableEarliestStart = dayjs(entry.startTime).hour();
        /* eslint-enable no-param-reassign */
        return entry;
      })
      state.appointments = mergeArray(state.appointments, tmp);
      state.appointments.sort((a, b) => dayjs(a.startTime).isSameOrBefore(dayjs(b.startTime)))
      if (!state.participant.earliestEventHour || timetableEarliestStart < state.participant.earliestEventHour) {
        state.participant = { ...state.participant, earliestEventHour: timetableEarliestStart };
      }
      state.loadingState = { ...state.loadingState, timetable: LoadingState.LOADED }
    }
    state.runState = state.runInformation.status;
    state.loadingState = { ...state.loadingState, runInformation: LoadingState.LOADED }
  },
  // used for new getParticipantStatus Endpoint
  [ACTIONS.SET_PARTICIPANT_STATUS]: (state, payload) => {
    if (payload.participant) state.participant = { ...state.participant, ...payload.participant };
  },
  // used for new getCandidateRuninformation Endpoint
  [ACTIONS.SET_PARTICIPANT_RUN_INFO]: (state, payload) => {
    if (payload.runInformation) {
      state.runInformation = { ...state.runInformation, ...payload.runInformation };
      state.runState = payload.runInformation.status
    }
  },
  [ACTIONS.SET_RUN_STATE]: (state, payload) => {
    state.runInfo.runInformation.runState = payload;
    state.runState = payload;
  },
  [ACTIONS.UPDATE_RUN_STATE]: (state, { runState }) => {
    state.runState = runState;
    state.runInfo.runInformation.runState = runState;
  },
  [ACTIONS.SET_RUN_INFO_LOADINGSTATE]: (state, { type, loadingState }) => {
    state.loadingState = { ...state.loadingState, [type]: loadingState }
  },
  [ACTIONS.SET_CURRENT_EXERCISE]: (state, payload) => {
    state.currentExerciseId = payload
    state.currentExerciseDocumentsLoadingState = LoadingState.INITIAL;
  },
  [ACTIONS.SET_PARTICIPANT_EXERCISE_STATUS_LOADINGSTATE]: (state, payload) => {
    state.loadingState = { ...state.loadingState, openExerciseStatus: payload }
  },
  [ACTIONS.SET_OPEN_EXERCISE_ID]: (state, payload) => {
    state.openExerciseId = payload;
  },
  [ACTIONS.SET_RUN_DOCUMENTS]: (state, payload) => {
    state.runDocuments = payload;
    state.loadingState = { ...state.loadingState, runDocuments: LoadingState.LOADED }
  }
}

export default mutations
